import { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";

interface Props {
  /** URL del logo. Si no hay (o falla la carga) se dibuja el nombre de la financiera. */
  logo?: string;
  financiera: string;
  maxHeight: number;
  maxWidth: number | string;
}

/**
 * Logo de la financiera con respaldo al nombre cuando no hay imagen o la carga falla,
 * igual que la tarjeta legacy. Lo usan la tarjeta de preoferta, la vista comparar y los
 * modales de confirmar/descartar.
 */
export const FinancieraLogo = ({ logo, financiera, maxHeight, maxWidth }: Props) => {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [logo]);

  if (!logo || failed) {
    return (
      <Typography sx={{ fontSize: 17, fontWeight: 600, color: "primary.dark", textAlign: "center", px: 1 }}>
        {financiera}
      </Typography>
    );
  }

  return (
    <Box
      component="img"
      src={logo}
      alt={financiera}
      onError={() => setFailed(true)}
      sx={{ display: "block", maxHeight, maxWidth, objectFit: "contain" }}
    />
  );
};
